import React from "react";
import { Typography, Alert, Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Account } from "@rentablo/api/apiv1";
import { goToDashboard } from "@helpers/mainAppUrls";
import { AccountList } from "./AccountList";

export interface Props {
  depots: Account[];
  status: "success" | "error" | "inProgress";
  errorMessage?: string;
}

export const ImportingData = ({ status, errorMessage, depots }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography variant="h4" component="h1" mb={6}>
        {t("netfondsConsent.importingData")}
      </Typography>

      <Typography variant="body1" mb={8}>
        {t("netfondsConsent.importingDataDescription")}
      </Typography>

      <Box mb={status !== "inProgress" ? 8 : 0}>
        <AccountList accounts={depots} />
      </Box>
      {status !== "inProgress" && (
        <>
          <Box mb={3}>
            <Alert severity={status}>
              {status === "error"
                ? errorMessage
                : t("bankConnections.success.message")}
            </Alert>
          </Box>
          <Button variant="primary" onClick={() => goToDashboard()}>
            {t("bankConnections.success.toDepots")}
          </Button>
        </>
      )}
    </>
  );
};
